<kendo-dialog class="ref-list-translate-dialog dataverse-dialog" (close)="closeDialog()" [minWidth]="250" [width]="800">
    <section class="align-center">
        <h2> {{ 'dataverse.supportedFieldDropdown.title' | translate }}</h2>
        <h3>{{fieldName}}</h3>
        <h3> {{ 'dataverse.supportedFieldDropdown.subTitle' | translate }} {{referenceListid}}</h3>
        <h3 *ngIf="errorMsg" class="errorMsg">{{errorMsg}}</h3>
    </section>

<section class="ref-list-translate-dialog " *ngIf="!displayLoader">
    <kendo-grid #grid [kendoGridBinding]="translationModel" (dataStateChange)="onStateChange($event)"
        (cellClick)="cellClickHandler($event)" (cellClose)="cellCloseHandler($event)" [pageable]="true"
        [pageSize]="5">

        <kendo-grid-column class="k-grid-ignore-click" field="id" title="{{'dataverse.supportedFieldDropdown.id' | translate | uppercase}}"></kendo-grid-column>
        <kendo-grid-column class="k-grid-ignore-click" field="description"
            title="{{'dataverse.supportedFieldDropdown.englishTranslation' | translate | uppercase}}"></kendo-grid-column>
        <kendo-grid-column field="translation" title="{{'dataverse.supportedFieldDropdown.translatedValue' | translate | uppercase}}"></kendo-grid-column>
    </kendo-grid>
</section>

<h3 class="ref-list-translate-dialog align-center" *ngIf="displayLoader">Loading data...</h3>

    <kendo-dialog-actions>
        <button kendoButton (click)="saveData()" themeColor="primary" [disabled]="isSaveBtnDisabled()">
            {{ 'dataverse.supportedFieldDropdown.save' | translate }}
        </button>
        <button kendoButton (click)="closeDialog()" class="dataverse-btn-light">  {{ 'dataverse.supportedFieldDropdown.cancel' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>
